//#region src/components/ScalarHotkey/constants.ts
/** Screen reader labels for the hotkey modifiers */
var HOTKEY_LABELS = {
	"⌘": "Command",
	"^": "Control",
	"ctrl": "Control",
	"⌥": "Option",
	"alt": "Alt",
	"⇧": "Shift",
	"⇪": "Caps Lock",
	"↵": "Enter",
	"←": "Left Arrow",
	"→": "Right Arrow",
	"↑": "Up Arrow",
	"↓": "Down Arrow"
};
/** Symbols for the hotkey modifiers on MacOS */
var MODIFIER_KEY_SYMBOLS_MACOS = {
	Meta: "⌘",
	Shift: "⇧",
	Alt: "⌥",
	Control: "^"
};
/** Symbols for the hotkey modifiers outside of MacOS */
var MODIFIER_KEY_SYMBOLS = {
	Meta: "ctrl",
	Shift: "⇧",
	Alt: "alt",
	Control: "ctrl"
};
//#endregion
export { HOTKEY_LABELS, MODIFIER_KEY_SYMBOLS, MODIFIER_KEY_SYMBOLS_MACOS };

//# sourceMappingURL=constants.js.map